<template>
    <section class="text-white">
        <b-container class="">
            <b-row>
                <b-col sm="12" md="12" lg="12" style="margin-top: 120px;">
                    <h1 class="text-center font-weight-bold">
                        <span>CONTÁCTAME</span>
                    </h1>

                    <p class="text-center color-red" style="font-size: 2em">
                        <a class="color-red" target="_blank" href="mailto:diradolfo@icloud.com">
                            diradolfo@icloud.com
                        </a>
                    </p>
                    <p class="text-center">
                        WhatsApp:
                        <a class="color-red" target="_blank" href="https://wa.me/+528135633570">
                          +528135633570
                        </a>
                    </p>
                    <p class="text-center">
                        Los campos marcados con "<strong class="">*</strong>" son obligatorios.
                    </p>
                    <b-form method="post" action="mail-functions.php" @reset="onReset">
                        <b-form-group
                                id="input-name"
                                label="* Nombre:"
                                label-for="input-name"
                                description="Jamás compartiremos tus datos con nadie más."
                        >
                            <b-form-input
                                    required
                                    id="input-name"
                                    v-model="form.name"
                                    type="text"
                                    class="bg-dark"
                                    required
                                    placeholder="Ingresa tu nombre"/>
                        </b-form-group>
                        <b-form-group
                                id="input-email"
                                label="* Dirección de E-mail:"
                                label-for="input-email"
                                description="Jamás compartiremos tus datos con nadie más."
                        >
                            <b-form-input
                                    id="input-email"
                                    v-model="form.email"
                                    type="email"
                                    class="bg-dark"
                                    required
                                    placeholder="Ingresa tu e-mail"/>
                        </b-form-group>
                        <b-form-group
                                id="input-phone"
                                label="Teléfono:"
                                label-for="input-phone"
                                description="Jamás compartiremos tus datos con nadie más."
                        >
                            <b-form-input
                                    id="input-phone"
                                    v-model="form.phone"
                                    type="text"
                                    class="bg-dark"
                                    placeholder="Ingresa tu teléfono"/>
                        </b-form-group>
                        <b-form-group
                                id="input-message"
                                label="Mensaje:"
                                label-for="input-email"
                                description="Jamás compartiremos tus datos con nadie más."
                        >
                            <b-form-textarea
                                    class="bg-dark"
                                    id="input-message"
                                    v-model="form.message"
                                    placeholder="Escríbenos..."
                                    rows="3"
                                    max-rows="6"
                            />
                        </b-form-group>
                        <b-button type="reset" variant="danger">Limpiar datos</b-button>
                        <b-button style="margin-left: 15px" type="submit">Enviar mensaje</b-button>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </section>
</template>

<script>
    export default {
        name: "Contact",
        data() {
            return {
                form: {
                    email: '',
                    name: '',
                    phone: '',
                    message: ''
                },
            }
        },
        methods: {
            /*onSubmit(evt) {

            },*/
            onReset(evt) {
                evt.preventDefault();
                this.form = {
                    email: '',
                        name: '',
                        phone: '',
                        message: ''
                };
            }
        }
    }
</script>

<style scoped>

</style>
